/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  UpdateDocumentRequestDocument,
  UpdateDocumentRequestDocumentFromJSON,
  UpdateDocumentRequestDocumentFromJSONTyped,
  UpdateDocumentRequestDocumentToJSON
} from './UpdateDocumentRequestDocument'

/**
 *
 * @export
 * @interface UpdateDocumentRequest
 */
export interface UpdateDocumentRequest {
  /**
   *
   * @type {UpdateDocumentRequestDocument}
   * @memberof UpdateDocumentRequest
   */
  document?: UpdateDocumentRequestDocument
}

export function UpdateDocumentRequestFromJSON(json: any): UpdateDocumentRequest {
  return UpdateDocumentRequestFromJSONTyped(json, false)
}

export function UpdateDocumentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDocumentRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    document: !exists(json, 'document') ? undefined : UpdateDocumentRequestDocumentFromJSON(json['document'])
  }
}

export function UpdateDocumentRequestToJSON(value?: UpdateDocumentRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    document: UpdateDocumentRequestDocumentToJSON(value.document)
  }
}
